export default __webpack_public_path__ + "static/media/userProfileIcon.54dcef69.svg";